import { supabase } from '../supabase/client';
import { convertError } from '../../utils/error-converter';

export const authService = {
  async signIn(email: string, password: string) {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        console.error('❌ Auth Service: Sign in error:', error);
        throw convertError(error);
      }

      return data;
    } catch (error) {
      console.error('❌ Auth Service: Sign in error:', error);
      throw convertError(error);
    }
  },

  async signUp(email: string, password: string) {
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
      });

      if (error) {
        throw convertError(error);
      }

      return data;
    } catch (error) {
      throw convertError(error);
    }
  },

  async signOut() {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) {
        console.error('❌ Auth Service: Sign out error:', error);
        throw convertError(error);
      }
    } catch (error) {
      console.error('❌ Auth Service: Sign out error:', error);
      throw convertError(error);
    }
  },

  async resetPassword(email: string) {
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email);
      if (error) {
        throw convertError(error);
      }
    } catch (error) {
      throw convertError(error);
    }
  },

  async getCurrentUser(user_id: string) {
    try {
      const { data: user, error } = await supabase
        .from('users')
        .select(
          `
          id,
          email,
          firstname,
          lastname,
          roleid,
          role: roles(name)
        `
        )
        .eq('id', user_id)
        .single();

      if (error) {
        console.error('❌ Auth Service: Get user error:', error);
        throw convertError(error);
      }

      return user;
    } catch (error) {
      console.error('❌ Auth Service: Get user error:', error);
      throw convertError(error);
    }
  },

  async changePassword(newPassword: string) {
    try {
      const { error } = await supabase.auth.updateUser({
        password: newPassword,
      });
      if (error) {
        console.error('❌ Auth Service: Change password error:', error);
        throw convertError(error);
      }
    } catch (error) {
      console.error('❌ Auth Service: Change password error:', error);
      throw convertError(error);
    }
  },

  async changePasswordUsingSupabase(newPassword: string) {
    try {
      const { error } = await supabase.auth.updateUser({
        password: newPassword,
      });
      if (error) {
        console.error('❌ Auth Service: Change password error:', error);
        throw convertError(error);
      }
    } catch (error) {
      console.error('❌ Auth Service: Change password error:', error);
      throw convertError(error);
    }
  },

  async editProfile(userId: string, updates: { firstName?: string; lastName?: string; email?: string }) {
    try {
      console.log('Updating profile:', updates);
      const { data, error } = await supabase
        .from('users')
        .update({
          firstname: updates.firstName,
          lastname: updates.lastName,
          email: updates.email,
        })
        .eq('id', userId);

      if (error) {
        console.error('❌ Auth Service: Edit profile error:', error);
        throw convertError(error);
      }

      return data;
    } catch (error) {
      console.error('❌ Auth Service: Edit profile error:', error);
      throw convertError(error);
    }
  },

  onAuthStateChange(callback: (event: string, session: any) => void) {
    return supabase.auth.onAuthStateChange(callback);
  },
};
